import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VuePlayerPlugin from 'vue-youtube-iframe-api'

Vue.config.productionTip = false
Vue.use(VuePlayerPlugin)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
